interface NetopiaMobilpayIpn {
  orderId?: string
  action?: string
  errorCode?: string
  errorMessage?: string
  transactionId?: string
  processedAmount?: string
  originalAmount?: string
  rrn?: string
}

const SUCCESSFUL_ACTIONS = new Set(['confirmed', 'confirmed_pending', 'paid', 'paid_pending'])

function extractMobilpayError(mobilpay: Record<string, unknown>): { code?: string, message?: string } {
  if (mobilpay.error_code != null) {
    return {
      code: String(mobilpay.error_code),
      message: mobilpay.error_message != null ? String(mobilpay.error_message) : undefined,
    }
  }

  const errorNode = mobilpay.error as Record<string, unknown> | undefined
  if (!errorNode) return {}

  const attrs = errorNode.$ as Record<string, string> | undefined
  return {
    code: attrs?.code,
    message: errorNode._ != null ? String(errorNode._) : undefined,
  }
}

export function parseNetopiaMobilpayIpn(parsed: Record<string, unknown>): NetopiaMobilpayIpn {
  const orderNode = parsed.order as Record<string, unknown> | undefined
  const orderAttrs = orderNode?.$ as Record<string, string> | undefined
  const mobilpay = orderNode?.mobilpay as Record<string, unknown> | undefined
  if (!mobilpay) return { orderId: orderAttrs?.id }

  const error = extractMobilpayError(mobilpay)

  return {
    orderId: orderAttrs?.id,
    action: mobilpay.action != null ? String(mobilpay.action) : undefined,
    errorCode: error.code,
    errorMessage: error.message,
    transactionId: mobilpay.purchase_id != null
      ? String(mobilpay.purchase_id)
      : mobilpay.purchase != null
        ? String(mobilpay.purchase)
        : mobilpay.rrn != null && String(mobilpay.rrn) !== ''
          ? String(mobilpay.rrn)
          : undefined,
    processedAmount: mobilpay.processed_amount != null ? String(mobilpay.processed_amount) : undefined,
    originalAmount: mobilpay.original_amount != null ? String(mobilpay.original_amount) : undefined,
    rrn: mobilpay.rrn != null ? String(mobilpay.rrn) : undefined,
  }
}

export function isNetopiaPaymentSuccessful(ipn: Pick<NetopiaMobilpayIpn, 'action' | 'errorCode'>): boolean {
  if (!ipn.action || !SUCCESSFUL_ACTIONS.has(ipn.action)) return false
  if (ipn.errorCode && ipn.errorCode !== '0') return false
  return true
}
